import { useValue } from "@tldraw/state-react";
import type { Editor } from "./canvas";
import type { TLShapeId } from "@tldraw/tlschema";
import { targetFact, type ChangeItem } from "../shared/changes";
export function ChangeHighlights({
  editor,
  item,
  indices,
}: {
  editor: Editor;
  item: ChangeItem;
  indices: number[];
}) {
  const boxes = useValue(
    "change highlights",
    () =>
      indices.flatMap((i) => {
        const target = item.targets[i],
          fact = targetFact(target);
        if (fact.pageId !== editor.getCurrentPageId()) return [];
        const bounds =
          target.after && fact.id.startsWith("shape:")
            ? editor.getShapePageBounds(fact.id as TLShapeId)
            : null;
        const b = bounds ?? fact.bounds,
          start = editor.pageToScreen({ x: b.x, y: b.y }),
          end = editor.pageToScreen({ x: b.x + b.w, y: b.y + b.h });
        return [
          {
            id: fact.id,
            x: start.x - 5,
            y: start.y - 5,
            w: Math.max(12, end.x - start.x + 10),
            h: Math.max(12, end.y - start.y + 10),
            removed: !target.after,
          },
        ];
      }),
    [editor, item, indices],
  );
  return (
    <svg className="change-highlights" aria-hidden="true">
      {boxes.map((b) => (
        <g key={b.id}>
          <rect x={b.x} y={b.y} width={b.w} height={b.h} />
          {b.removed && (
            <text x={b.x + 4} y={b.y - 8}>
              Removed · former location
            </text>
          )}
        </g>
      ))}
    </svg>
  );
}
